import React, { PropsWithChildren, useState } from 'react';
import { DropTargetMonitor, useDrop } from 'react-dnd';
import { MdHome } from 'react-icons/md';
import { CodeDragItemType } from 'app/area/codetable/list/constants';
import { animationTimeout } from 'app/area/codetable/list/list-items/drag-and-drop/constants';
import { CodeListBranch, CodeListItem } from 'app/area/codetable/list/types-store';
import { getDirectParentsList } from 'app/area/codetable/list/code-list-helpers';
import styles from './code-drop.scss';

interface CodeDropProps {
  codeListBranch: CodeListBranch[];
  dropCodeId: number;
  type: CodeDragItemType;
  isRoot?: boolean;
  updateCodeParent: (dragCodeId: number, dropCodeId: number, description: string) => void;
}

export const CodeDrop = ({
  codeListBranch, dropCodeId, type, isRoot = false, children, updateCodeParent
}: PropsWithChildren<CodeDropProps>) => {

  const [animation, setAnimation] = useState(false);

  const [{ hovered }, dropRef] =
    useDrop({
      accept: type,
      canDrop: (draggedItem: CodeListItem, _: DropTargetMonitor) => {
        const parents = getDirectParentsList(codeListBranch, dropCodeId);
        return !parents.includes(draggedItem.id);
      },
      drop: (_, monitor) => {
        const dragCode = monitor.getItem() as { id: number; description: string };

        if (dragCode?.id === dropCodeId) {
          return;
        }

        setAnimation(true);
        updateCodeParent(dragCode?.id, isRoot ? null : dropCodeId, dragCode?.description);
        setTimeout(() => setAnimation(false), animationTimeout);
      },
      collect: (monitor) => ({
        hovered: monitor.isOver()
      })
    });

  return <div ref={dropRef}
    className={`
    ${animation ? styles.animation : ''}  
      ${isRoot
        ? (hovered ? styles.rootHovered : styles.rootDefault)
        : (hovered ? styles.itemHovered : '')}
        `}>
    {isRoot
      ? <div className={styles.rootRow}>
        <MdHome />
      </div>
      : children}
  </div>;
};
